import type { IOrganisation } from "@bbj-types/organisation";
import type { ObjectId } from "@bbj-types/utils";
import { useSuspense } from "@root/api/tools/axios";
import { useCallback } from "react";
import { axiosInstance, axiosSettings } from "./axios";

export type TGetOrganisationChild = {
  _id: ObjectId;
  name: string;
  userCount: number;
  teamCount: number;
  features: { team: { active: boolean } };
};

export type TGetOrganisationsResponseV2 = Pick<IOrganisation, "_id" | "name"> & {
  features: { team: { active: boolean } };
  isMaster: boolean;
  childrens: TGetOrganisationChild[];
};

export const useGetOrganisationsV2 = () => {
  const [state, execute, cancel] = axiosSettings<TGetOrganisationsResponseV2[], void, unknown>(
    {
      method: "GET",
      withCredentials: true,
    },
    { manual: true }
  );

  const callback = useCallback(() => {
    return execute({
      url: "/v2/organisations",
    });
  }, [execute]);

  return [state, callback, cancel] as const;
};

export const useGetOrganisationsV2Suspense = () => {
  return useSuspense(
    () =>
      axiosInstance.get<TGetOrganisationsResponseV2[]>("/v2/organisations", {
        withCredentials: true,
      }),
    []
  );
};
